var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-main has-bottom" },
        [
          _c("page-title"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "init-page" },
            [
              _c(
                "page-card",
                [
                  _c("template", { slot: "header" }, [
                    _vm._v(" Well Information "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      attrs: { slot: "body" },
                      slot: "body",
                    },
                    [
                      _c("wellComp", {
                        ref: "addWellComp",
                        attrs: { type: "edit", "remove-disabled": true },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "page-bottom",
        [
          [
            _c(
              "div",
              { staticClass: "page-btns" },
              [
                _c("el-button", { on: { click: _vm.goback } }, [
                  _vm._v("Cancel"),
                ]),
                _vm._v(" "),
                _c("loading-btn", {
                  attrs: { label: "Submit", type: "primary" },
                  on: { clickHandle: _vm.submit },
                }),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }